
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface EventLimitsBannerProps {
  subscriptionType?: "free" | "pro";
  eventsCreated?: number;
}

const EventLimitsBanner = ({ subscriptionType = "free", eventsCreated = 0 }: EventLimitsBannerProps) => {
  const navigate = useNavigate();
  
  // Only show for free accounts
  if (subscriptionType === "pro") {
    return null;
  }
  
  const FREE_EVENTS_LIMIT = 10;
  const eventsRemaining = FREE_EVENTS_LIMIT - eventsCreated;
  const progress = (eventsCreated / FREE_EVENTS_LIMIT) * 100;
  
  return (
    <Alert className="mb-6 border-amber-200 bg-amber-50">
      <AlertTitle className="flex justify-between items-center">
        <span>Free Account Limits</span>
        <Button 
          size="sm" 
          variant="default"
          onClick={() => navigate("/pricing")}
        >
          Upgrade
        </Button>
      </AlertTitle>
      <AlertDescription className="mt-2">
        <div className="mb-2">
          <div className="flex justify-between mb-1">
            <span>Events Created</span>
            <span className="font-medium">{eventsCreated}/{FREE_EVENTS_LIMIT}</span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>
        <p className="text-sm text-amber-800">
          {eventsRemaining > 0
            ? `You can create ${eventsRemaining} more events with your free account.`
            : "You've reached the limit of events for your free account. Upgrade to create more events."}
        </p>
      </AlertDescription>
    </Alert>
  );
};

export default EventLimitsBanner;
